/**
 *
 * RoutesManager
 *
 */

import React, { useCallback, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { FormattedMessage } from 'react-intl';
import { useSessionStorage } from 'react-use';
import { Modal } from 'react-bootstrap';
import withRoute from 'containers/withRoute';
import withRoutes from 'containers/Routes/withEntity';
import { listFromId } from 'utils/arrays';
import messages from './messages';
import RoutesTable from './RoutesTable';
import RoutesHeader from './RoutesHeader';

function filterRoutes(routes, filter) {
  if (routes.loading || !routes.list) {
    return {};
  }
  const re = new RegExp(filter, 'i');
  const match = route => re.test(route.title) || re.test(route.city);
  const allRoutes = listFromId(routes, 'list');
  const totalCount = allRoutes.length;
  const filtered = filter ? allRoutes.filter(match) : allRoutes;
  const filterCount = filtered.length;
  return {
    totalCount,
    filterCount,
    filtered,
  };
}

function RoutesManager(props) {
  const { routes, apiList, apiReset, apiChange, hashClear } = props;
  const [filter, setFilter] = useSessionStorage('');

  useEffect(() => {
    apiList();
  }, []);

  const changeFilter = useCallback(ev => setFilter(ev.target.value), [
    setFilter,
  ]);

  const { totalCount, filterCount, filtered } = useMemo(
    () => filterRoutes(routes, filter),
    [routes, filter],
  );

  const handleClose = useCallback(
    () => {
      apiReset();
      hashClear();
    },
    [apiReset, hashClear],
  );

  const showRoutes = routes && filterCount > 0;
  return (
    <Modal show bsSize="lg" onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>
          <FormattedMessage {...messages.header} />
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="help-block">
          <FormattedMessage {...messages.sortRoutes} />
          <br />
          <FormattedMessage {...messages.filterRoutes} />
        </p>
        <RoutesHeader
          filter={filter}
          routes={filtered}
          totalCount={totalCount}
          filterCount={filterCount}
          changeFilter={changeFilter}
        />
      </Modal.Body>
      {showRoutes && <RoutesTable routes={filtered} onChange={apiChange} />}
    </Modal>
  );
}

RoutesManager.propTypes = {
  routes: PropTypes.object.isRequired,
  apiList: PropTypes.func.isRequired,
  apiReset: PropTypes.func.isRequired,
  apiChange: PropTypes.func.isRequired,
  hashClear: PropTypes.func.isRequired,
};

export default compose(
  withRoute,
  withRoutes,
)(RoutesManager);
